/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, Fragment} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {useUserSelector} from '../../../../app/store/user'
import {IMapCompany} from '../../../../app/interface/user/user'

const HeaderUserMenu: FC = () => {
  const {logout} = useAuth()
  const {user, isUser, myCompany} = useUserSelector()

  const onSelectCompany = (company: IMapCompany) => {
    if (myCompany?.company.name === company.company.name) return
    localStorage.setItem('myCompany', JSON.stringify(company))
    window.location.href = '/'
    // window.location.reload()
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      {isUser && (
        <div
          className='menu-item px-5'
          data-kt-menu-trigger='hover'
          data-kt-menu-placement='left-start'
          data-kt-menu-flip='bottom'
        >
          <label className='menu-link px-5'>
            <span className='menu-title'>My Company</span>
            <span className='menu-arrow'></span>
          </label>

          <div className='menu-sub menu-sub-dropdown w-175px py-4'>
            {user?.companies.map((item, i) => {
              return (
                <Fragment key={i}>
                  <div className='menu-item px-3' onClick={() => onSelectCompany(item)}>
                    <a href='#' className='menu-link px-5'>
                      <span
                        className={
                          myCompany?.company.name === item.company.name ? 'link' : 'menu-title'
                        }
                      >
                        {item.company.name}
                      </span>
                    </a>
                  </div>
                </Fragment>
              )
            })}
          </div>
        </div>
      )}
      {/* <div className='menu-item px-5 my-1'>
        <Link to='#' className='menu-link px-5'>
          User Role
        </Link>
      </div> */}
      <div className='menu-item px-5 my-1'>
        <Link to='#' className='menu-link px-5'>
          <span className='menu-title'>Change Password</span>
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          <span className='menu-title'>Sign Out</span>
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
